<script lang="ts" setup>
interface ButtonProps {
  type?:
    | "is-ghost"
    | "is-link"
    | "is-white"
    | "is-primary"
    | "is-secondary"
    | "is-light"
    | "is-dark";
  size?: "is-default" | "is-small" | "is-medium" | "is-large";
  rounded?: boolean;
  inverted?: boolean;
  outlined?: boolean;
  disabled?: boolean;
  loading?: boolean;
  iconLeft?: string;
  iconRight?: string;
  tooltipRight?: boolean;
  iconLeftSlot?: boolean;
  expanded?: boolean;
  iconPack?: string;
}

const {
  type,
  size,
  rounded = true,
  inverted = false,
  outlined = false,
  disabled = false,
  loading = false,
  iconLeft,
  iconRight,
  tooltipRight = false,
  iconLeftSlot = false,
  expanded = false,
  iconPack = "fas"
} = defineProps<ButtonProps>();
</script>

<template>
  <b-button
    :type="type"
    :size="size"
    :rounded="rounded"
    :inverted="inverted"
    :outlined="outlined"
    :disabled="disabled"
    :loading="loading"
    :icon-left="iconLeft"
    :icon-right="iconRight"
    :expanded="expanded"
    :icon-pack="iconPack"
  >
    <div class="main-content-button">
      <div v-if="iconLeftSlot" class="left_icon">
        <slot name="left_icon" />
      </div>
      <slot name="default" />
      <slot v-if="tooltipRight" name="tooltipRight" />
    </div>
  </b-button>
</template>

<style lang="scss" scoped>
.main-content-button {
  display: flex;
  flex-direction: row;
  justify-content: left;
  flex-wrap: wrap;
  align-content: center;
  gap: 8px;
  font-family: $family-heading;
  font-weight: 600;
  font-size: $size-normal;

  .left_icon {
    height: 16px;
    width: 16px;
    transform: translateY(3px);
  }
}

.is-default {
  padding: 7px 16px;
  gap: 12px;
  font-style: normal;
  line-height: 25.6px;
}
.is-small {
  padding: 5px 12px;
  gap: 9px;
  font-style: normal;
  line-height: 20px;
}
.is-medium {
  padding: 9px 20px;
  gap: 15px;

  font-style: normal;
  line-height: 32px;
}
.is-large {
  padding: 11px 24px;
  gap: 18px;
  font-style: normal;
  line-height: 38.4px;
}
</style>
